var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"nav"},[_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("달력보기")])],1),_c('p',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("지도 인터렉션")])],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }